module.exports = __webpack_public_path__ + "img/Mardona-9.94e7fc97.webp";